import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';

i18next.addResourceBundle('en', 'devicePage', en);

const DeviceConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/devices',
			exact: true,
			component: React.lazy(() => import('./Device'))
		}
	]
};

export default DeviceConfig;
